import _ from "lodash";

function processDestinationListingParams(params) {
  const queryParams = new URLSearchParams(params);

  const processedParams = {
    propertyDetails: {
      propertyId: null,
      propertyName: null,
    },
    bookingDates: {
      checkinDate: null,
      checkoutDate: null,
    },
    filters: {
      starRating: [],
      propertyTypeId: [],
    },
    guests: {
      adultCount: 2,
      childCount: 0,
      childAges: [],
      roomCount: 1,
    },

    sortOptions: {
      by: null,
      order: null,
      type: null,
    },

    pagination: {
      limit: 20,
      page: 1,
    },
  };

  for (let [key, value] of queryParams.entries()) {
    // convert null and undefined values to null
    if (value === "null" || value === "undefined") {
      value = null;
    }

    switch (key) {
      case "property-id":
        processedParams.propertyDetails.propertyId = value ?? null;
        break;

      case "location":
        processedParams.location.label = value ? decodeURIComponent(value) : null;
        if (queryParams.has("property-id")) {
          processedParams.propertyDetails.propertyName = value ? decodeURIComponent(value) : null;
        }
        break;

      case "sortType":
        const { sortBy, sortOrder } = convertSortingValue(value);

        processedParams.sortOptions.by = sortBy;
        processedParams.sortOptions.order = sortOrder;
        processedParams.sortOptions.type = value;

        break;

      case "starRating":
        processedParams.filters.starRating = value
          .split(",")
          .map((star) => parseIntOrDefault(star, null))
          .filter((star) => star !== null);
        break;

      case "page-size":
        processedParams.pagination.limit = parseIntOrDefault(value, 20);
        break;

      case "page":
        processedParams.pagination.page = parseIntOrDefault(value, 1);
        break;

      default:
        break;
    }
  }

  return processedParams;
}

function generateDestinationListingUrl({ searchCriteria = {}, filters = {}, pagination = null, sortType = null }) {
  const { propertyDetails = {}, location = {} } = searchCriteria || {};

  const propertyId = propertyDetails.propertyId ?? null;
  const propertyName = propertyDetails.propertyName ?? null;
  const label = location.label ?? "";

  const { propertyType, starRating } = filters;

  const queryParams = new URLSearchParams();

  // Ensure starRating is an array before processing
  if (starRating && starRating.length > 0) {
    queryParams.append("starRating", starRating.join(","));
  }

  if (propertyId) {
    queryParams.append("property-id", propertyId);
  }

  if (propertyName) {
    queryParams.append("location", propertyName);
  }

  // Default sortType to "topReviewed" if not provided
  const effectiveSortType = sortType ?? "topReviewed";
  queryParams.append("sortType", effectiveSortType);

  const { limit, page } = pagination || {};

  queryParams.append("limit", limit?.toString() ?? "20");
  queryParams.append("page", page?.toString() ?? "1");

  const basePath = encodeURI(`/lk/destinations/${label}${propertyType ? `/${propertyType}` : ""}`);
  const url = `${basePath}?${queryParams.toString()}${window.location.hash}`;

  return url;
}

export { processDestinationListingParams, generateDestinationListingUrl };

function convertSortingValue(value) {
  const mapping = {
    starRatingHighest: {
      sortBy: "rating",
      sortOrder: "desc",
    },
    starRatingLowest: {
      sortBy: "rating",
      sortOrder: "asc",
    },
    topReviewed: {
      sortBy: "score",
      sortOrder: "desc",
    },
    default: { sortBy: null, sortOrder: null },
  };

  return mapping[value] ?? mapping.default;
}

function parseIntOrDefault(value, defaultValue) {
  const parsed = parseInt(value);
  return isNaN(parsed) ? defaultValue : parsed;
}
